import * as React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { Modal, Typography } from "@mui/material";
import { SubjectPageItem } from "../../components/Subject-page/SubjectPageItem";
import { useLocation } from "react-router-dom";
import { getVideoByLessonId } from "../../apiCalls/userApiCalls";
import { useDispatch, useSelector } from "react-redux";
import CommonHeader from "../../components/common/commonHeader/CommonHeader";
import { Loader } from "../../components/loaderComponent/Loding";
import WarningIcon from "@mui/icons-material/Warning";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function isDateDifferenceGreaterThan15Days(date1, date2,dueDate) {
  var oneDay = 24 * 60 * 60 * 1000; // Number of milliseconds in a day

  var parsedDate1 = new Date(date1);
  var parsedDate2 = new Date(date2);
  var dueDate = new Date(dueDate);

  var differenceInDays = Math.round(
    Math.abs((parsedDate1 - parsedDate2) / oneDay)
  );

  var overDue=
   ((dueDate - parsedDate1) / oneDay)
  ;
  console.log("overDue",differenceInDays > 15);
  return overDue<0 ;
}

function checkWatchTime(count) {
  if (count === undefined) {
    return false;
  }
  return count > 5;
}

export const SubjectPage = () => {
  const location = useLocation();
  const { state } = location;
  const dispatch = useDispatch();
  const user = JSON.parse(sessionStorage.getItem("user"));
  const isLoading = useSelector((state) => state.video.isFetching);
  const today = new Date();

  const [openModel, setOpenLoginModel] = React.useState(false);
  const handleCloseModel = () => setOpenLoginModel(false);

  const videos = useSelector((state) => state.video.videos);

  //console.log("videos", videos);
  React.useEffect(() => {
    if (state?.lesson?._id) {
      getVideoByLessonId(state.lesson._id, user._id, dispatch);
      setOpenLoginModel(true);
    }
  }, []);

  return (
    <React.Fragment>
      <CommonHeader />
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Box sx={{ width: "100%", height: "80px" }}></Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Typography
              variant="h3"
              sx={{ fontWeight: 700, fontFamily: "Noto Sans Sinhala" }}
            >
              {state?.lesson?.lessonName}
            </Typography>
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              sx={{ mt: 2, ml: 5 }}
            >
              {videos.length > 0 ? (
                videos.map((video, index) => {

                  let  modifiedVideo = {
                    ...video,
                    isLocked: false
                  }
                  if(isDateDifferenceGreaterThan15Days(
                    today,
                    video.createdAt,
                    video?.dueDate
                  ) ||
                    checkWatchTime(video?.watchTime?.watchCount)){
                    modifiedVideo = {
                      ...video,
                      isLocked: true
                    }
                  }
          
                  return (
                    <>
                      { (
                          <Grid key={index} item xs={12} sm={6} md={6} lg={4}>
                            <SubjectPageItem video={modifiedVideo} />
                          </Grid>
                        )}
                    </>
                  );
                })
              ) : (
                <Grid
                  container
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  justifyContent={"center"}
                >
                  <Typography
                    variant="h5"
                    sx={{ fontWeight: 400, marginTop: "100px" }}
                  >
                    No Videos
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Box>

          <Modal
            open={openModel}
            onClose={handleCloseModel}
            aria-labelledby="keep-mounted-modal-title"
            aria-describedby="keep-mounted-modal-description"
          >
            <Box sx={style}>
              <WarningIcon sx={{ fontSize: "50px", color: "red" }} />
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 500,
                  display: "inline",
                  fontSize: "30px",
                  color: "red",
                  marginTop: "30px",
                }}
              >
                Warning
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 500,
                  border: "2px solid #000",
                  padding: "10px",
                  fontSize: "20px",
                }}
              >
                "ඔබ මෙම වීඩියෝ සඳහා උපරිම නැරඹුම් 5කට සීමා කර ඇත."
              </Typography>
            </Box>
          </Modal>
        </>
      )}
    </React.Fragment>
  );
};
